import { Injectable } from '@angular/core';
import { UserDefinedWidgetType } from '@constants/pages/user-defined-page/user-defined-widget-type';
import { LineChartSettingsParameters } from '@models/charts/line-chart-settings-parameters';
import { BarChartDataUpdateService } from '@services/charts/bar/bar-chart-data-update.service';
import { GaugeChartDataUpdateService } from '@services/charts/gauge/gauge-chart-data-update.service';
import { LineChartDataUpdateService } from '@services/charts/line/line-chart-data-update.service';
import { PieChartDataUpdateService } from '@services/charts/pie/pie-chart-data-update.service';
import { Chart } from 'highcharts';

@Injectable({
  providedIn: 'root'
})
export class GeneralChartDataUpdateService {

  constructor(private gaugeChartDataUpdateService: GaugeChartDataUpdateService,
              private barChartDataUpdateService: BarChartDataUpdateService,
              private lineChartDataUpdateService: LineChartDataUpdateService,
              private pieChartDataUpdateService: PieChartDataUpdateService) {
  }

  public updateChartData(widgetType: UserDefinedWidgetType, chart: (Chart | undefined), parameters: LineChartSettingsParameters, data: any[]) {
    if (!chart) {
      return;
    }
    switch (widgetType) {
      case UserDefinedWidgetType.LINE_WITH_SIGNALS_PER_AXIS:
        this.lineChartDataUpdateService.updateChartData(chart, parameters, data);
        break;
      case UserDefinedWidgetType.BAR:
        this.barChartDataUpdateService.updateChartData(chart, parameters, data);
        break;
      case UserDefinedWidgetType.GAUGE:
        this.gaugeChartDataUpdateService.updateChartData(chart, data);
        break;

      case UserDefinedWidgetType.PIE:
        this.pieChartDataUpdateService.updateChartData(chart, parameters, data);
        break;

    }
    chart.redraw();

  }

  public getHighChartById(id: string | undefined, charts: (Chart | undefined)[]): Chart | undefined {
    if (!id || !charts || charts.length === 0) {
      return undefined;
    }

    for (const chart of charts) {
      if (!chart || !chart.userOptions || !chart.userOptions.credits) {
        continue;
      }
      if (chart.userOptions.credits.text === String(id)) {
        return chart;
      }
    }
    return undefined;
  }

  public prepareDataToDisplay(widgetType: UserDefinedWidgetType, data: any[]): any[] {
     switch (widgetType) {
      case UserDefinedWidgetType.LINE_WITH_SIGNALS_PER_AXIS:
        return data.sort((m1, m2) => (((m1.ts && m2.ts) && (m1.ts > m2.ts)) ? 1 : -1));

      case UserDefinedWidgetType.BAR:
      case UserDefinedWidgetType.GAUGE:
      case UserDefinedWidgetType.TEXT:
      case UserDefinedWidgetType.COMMAND:
      case UserDefinedWidgetType.PIE:
        const sortedValues = data.sort((m1, m2) => (((m1.ts && m2.ts) && (m1.ts > m2.ts)) ? -1 : 1));
        return [sortedValues[0]];

    }
    return [];
  }

}
